
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import paginacion from './lista-listado-paginacion.vue';
    import { ControladorSeccion } from './controlador';
    import { DataTableHeader } from 'vuetify';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import { Envio } from '@/__env/lib/Ventas/Envios';
    import { Utiles } from '@/__env/pluggins/event-bus';

    @Component( {
        name: "Componente",
        props: {},
        components: {
            paginacion
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }
        public get Estado() { return this.Controlador.Buscador.Estado; }
        public get Items() { return this.Controlador.Buscador.Items; }
        public get Seleccionados() { return this.Controlador.Seleccionados; }
        public get Modo() { return this.Controlador.Vista.Modo; }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }
        mounted()
        {

        }

        public get Headers(): Array<DataTableHeader>
        {
            if ( this.Modo == 'items' )
            {
                return [
                    { text: '', align: 'center', value: 'Imagen', width: '65px' },
                    { text: 'Codigo', align: 'start', value: 'Col1', },
                    { text: 'Cliente', align: 'start', value: 'Col2' },
                    { text: 'Estado', align: 'start', value: 'Col3' },

                    { text: 'Items', align: 'center', value: 'Items1' },
                    { text: '1er Artículo', align: 'center', value: 'Items2' },
                    { text: '', align: 'end', value: 'Col8' },
                ];
            }

            return [
                { text: '', align: 'center', value: 'Imagen', width: '65px' },
                { text: 'Codigo', align: 'start', value: 'Col1', },
                { text: 'Cliente', align: 'start', value: 'Col2' },
                { text: 'Estado', align: 'start', value: 'Col3' },
                { text: 'Logística', align: 'start', value: 'Col4' },

                { text: 'Tipo', align: 'end', value: 'Col6' },
                { text: 'Fecha', align: 'end', value: 'Col7' },
                { text: '', align: 'end', value: 'Col8' },
            ];

        }


        public CargandoMenu: boolean = false;
        public Opciones = [
            { Tipo: 'titulo', Titulo: 'Archivos' },
            {
                Tipo: 'opcion', Titulo: 'Nota de venta', Accion: async ( item: Pedido ) =>
                {

                    this.CargandoMenu = true;
                    Utiles.GenerandoArchivo( true );
                    let pdf = await Pedido.URLNotaDeVenta( [item] );
                    if ( pdf )
                    {
                        window.open( pdf );
                    } else
                    {
                        Utiles.Notificaciones.Error( `Error al generar archivo` );
                    }
                    Utiles.GenerandoArchivo( false );
                    this.CargandoMenu = false;
                }
            },

            {
                Tipo: 'opcion', Titulo: 'Presupuesto', Accion: async ( item: Pedido ) =>
                {

                    this.CargandoMenu = true; Utiles.GenerandoArchivo( true );
                    let pdf = await Pedido.URLPresupuesto( [item] );
                    if ( pdf )
                    {
                        window.open( pdf );
                    } else
                    {
                        Utiles.Notificaciones.Error( `Error al generar archivo` );
                    }
                    Utiles.GenerandoArchivo( false );
                    this.CargandoMenu = false;
                }
            },

            {
                Tipo: 'opcion', Titulo: 'Formulario MercadoPago', Accion: async ( item: Pedido ) =>
                {

                    this.CargandoMenu = true; Utiles.GenerandoArchivo( true );
                    let pdf = await Pedido.URLNotaMercadoPago( [item] );
                    if ( pdf )
                    {
                        window.open( pdf );
                    } else
                    {
                        Utiles.Notificaciones.Error( `Error al generar archivo` );
                    }
                    Utiles.GenerandoArchivo( false );
                    this.CargandoMenu = false;
                }
            },
            {
                Tipo: 'opcion', Titulo: 'Etiqueta envío', Accion: async ( item: Pedido ) =>
                {
                    if ( item.Envio.Tipo.esMercadoEnvios || item.Envio.Tipo.esFlex )
                    {
                        this.CargandoMenu = true; Utiles.GenerandoArchivo( true );
                        let pdf = await Envio.Etiquetas( item.Cuenta, [item.Envio.IdExterna] );
                        if ( pdf )
                        {
                            window.open( pdf );
                        } else
                        {
                            Utiles.Notificaciones.Error( `Etiquetas para ${item.Cuenta} no encontradas!` );
                        }
                        Utiles.GenerandoArchivo( false);
                        this.CargandoMenu = false;
                    } else
                    {
                        Utiles.Notificaciones.Error( `Etiquetas solo disponible para MercadoEnvios.` );

                    }

                }
            },
        ];

        Abrir( item: Pedido )
        {
            this.Controlador.Seleccionados.clear();
            this.Controlador.Seleccionados.push( item );
        }


        AbrirEnOtraPestaña( item: Pedido )
        {
            this.Controlador.AbrirEnOtraPestaña( item );
        }
    }
